import {t} from '../../../../../../services/i18n';
import {ALL_LOCATIONS_KEY} from '../ChooseHug/hugFiltersConfig';

export {ALL_LOCATIONS_KEY};

export const getTrackFiltersConfig = ({isMultiLocation, locationOptions, userLocation}) => [
    {
        key: 'location',
        show: isMultiLocation,
        defaultValue: userLocation?.id ?? ALL_LOCATIONS_KEY,
        options: locationOptions,
        filterFunc: (track, value) => !value || value === ALL_LOCATIONS_KEY || (track.locations_box_fk ?? track.locations_box?.id) === value,
        style: {maxWidth: '25%', flex: 1},
        showSearch: true,
    },
];
